module.exports = __webpack_public_path__ + "img/th.904dd785.svg";